var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPClosedAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 6.75V9.75M9 12.75H9.0075M7.725 2.925L1.35 13.5C1.21932 13.7263 1.15001 13.9828 1.14894 14.244C1.14787 14.5053 1.21507 14.7624 1.34389 14.9897C1.47272 15.217 1.65869 15.4068 1.88339 15.5401C2.1081 15.6735 2.36374 15.7458 2.625 15.75H15.375C15.6363 15.7458 15.8919 15.6735 16.1166 15.5401C16.3413 15.4068 16.5273 15.217 16.6561 14.9897C16.7849 14.7624 16.8521 14.5053 16.8511 14.244C16.85 13.9828 16.7807 13.7263 16.65 13.5L10.275 2.925C10.1405 2.70793 9.95276 2.52881 9.72964 2.40459C9.50651 2.28037 9.25537 2.21517 9 2.21517C8.74463 2.21517 8.49349 2.28037 8.27036 2.40459C8.04724 2.52881 7.85952 2.70793 7.725 2.925Z",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#D70015"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPClosedAlert);
export default __webpack_public_path__ + "static/media/p_closed_alert.25905094b968c3bff18da498eaa1fbb2.svg";
export { ForwardRef as ReactComponent };